export const ACCOUNT_CONFIG = {
  PENDING_EXPIRY_DAYS: 3 // Change this ONE value to update everywhere
};
